import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';

import axios from 'axios';
import { Mensaje, MensajeSiNo } from '../mensajes2';
import { Dimmer } from '../spinner';

import moment from 'moment';

export const ImprimirCompOrdServc = (props) => {

    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
    const efiscalanio = JSON.parse(localStorage.getItem('efiscalanio'));
    const fechaSistema = JSON.parse(localStorage.getItem('fechasistema'));
    const espiritu = JSON.parse(localStorage.getItem('espiritu'));

    const [activate, setActivate] = useState(false);
    const [desde, setDesde] = useState('');
    const [hasta, setHasta] = useState('');
    const [activo, setActivo] = useState(false);
    const [condi, setCondi] = useState('true');
    const [valtipo, setValtipo] = useState(0);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const btnCancela = useRef();
    const btnAcepta = useRef();
    const txtTipo = useRef();
    const txtDesde = useRef();
    const txtHasta = useRef();

    const onChangeValidar = (e) => {
        e.preventDefault();
        var sigue = true;
        if (txtDesde.current.value === "") {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'La Fecha Desde no debe ir Vacio!', icono: 'informacion' });
            sigue = false;
            txtDesde.current.focus();
        } else if (txtHasta.current.value === "") {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'La Fecha Hasta no debe ir Vacio!', icono: 'informacion' });
            sigue = false;
            txtHasta.current.focus();
        } else if (valtipo === 2) {

            if (txtTipo.current.value === "") {
                setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Seleccione el Tipo de Compromiso!', icono: 'informacion' });
                sigue = false;
                txtTipo.current.focus();
            } else {
                imprimirGeneral(desde, hasta, condi)
            }

        } else if (sigue) {
            imprimirGeneral(desde, hasta, condi)
        }

    };

    const onChange = (e) => {

        if (e.target.id === 'desde') {
            setDesde(e.target.value);
            //setValtipo(1);
        } else if (e.target.id === 'hasta') {
            setHasta(e.target.value);
            //setValtipo(1);
        }


        if (e.target.id === 'tipo') {
            if (e.target.value === '1') {
                setCondi("true");
                setValtipo(2);
            } else if (e.target.value === '2') {
                setCondi("CPG.tipo = 5");
                setValtipo(2);
            } else if (e.target.value === '3') {
                setCondi("CPG.tipo = 7");
                setValtipo(2);
            } else if (e.target.value === '4') {
                setCondi("CPG.tipo = 11");
                setValtipo(2);
            } else if (e.target.value === '5') {
                setCondi("CPG.tipo = 12");
                setValtipo(2);
            } else if (e.target.value === '6') {
                setCondi("CPG.tipo = 13");
                setValtipo(2);
            }
        } else {
            setCondi("true");
        }

    };


    const imprimirGeneral = (desde, hasta, condic) => {

        var reporte = "";
        var sql = "";
        var sql1 = "";
        let desdec = moment.utc(desde).format('DD-MM-YYYY');
        let hastac = moment.utc(hasta).format('DD-MM-YYYY');
        var val = 0;

        if (props.condicion === 'Listado de Compromisos por Pagar') {

            reporte = 'Pres_CompromisoP';

            sql = " Between " + "'" + desdec + "'" + " AND " + "'" + hastac + "'";
            sql1 = "DESDE EL" + " " + "'" + desdec + "'" + " " + "HASTA EL" + " " + "'" + hastac + "'";
            val = 1;

        } else if (props.condicion === 'Listado de Compromisos por Causar') {

            reporte = 'Pres_CompromisoC';
            let desdc = moment.utc(desde).format('DD/MM/YYYY');
            let hastc = moment.utc(hasta).format('DD/MM/YYYY');

            sql = " Between " + "'" + desdec + "'" + " AND " + "'" + hastac + "'";
            sql1 = "DESDE EL" + " " + "'" + desdc + "'" + " " + "HASTA EL" + " " + "'" + hastc + "'";
            val = 1;

        } else if (props.condicion === 'Resumen de Compromisos por Beneficiarios') {

            reporte = 'Pres_CompromisoR';

            sql = " Between " + "'" + desdec + "'" + " AND " + "'" + hastac + "'";
            sql1 = "DESDE EL" + " " + "'" + desdec + "'" + " " + "HASTA " + " " + "'" + hastac + "'";
            val = 1;

        } else if (props.condicion === 'Listado General de Compromisos') {

            reporte = 'Pres_CompromisoFch';

            sql = "CPG.Fecha Between " + "'" + desdec + "'" + " AND " + "'" + hastac + "'";
            sql1 = "DESDE EL" + " " + "'" + desdec + "'" + " " + "HASTA " + " " + "'" + hastac + "'";
            val = 1;

        } else if (props.condicion === 'Listado por Tipo de Compromiso') {

            reporte = 'Pres_CompromisoClas';

            sql = "CPG.Fecha Between " + "'" + desdec + "'" + " AND " + "'" + hastac + "'";
            sql1 = "DESDE EL" + " " + "'" + desdec + "'" + " " + "HASTA " + " " + "'" + hastac + "'";
            val = 2;

        }


        window.open(op.reportes + "/contabilidadpresupuestaria?" + "reporte=" + reporte + "&idfiscal=" + idefiscal + "&sql=" + sql + "&sql1=" + sql1 + "&sql2=" + desdec + "&sql3=" + hastac + "&sql4=" + condic + "&val=" + val, "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700");
    }

    const cancelar = () => {
        blanquear();
        props.onHideCancela();
    }

    const blanquear = () => {
        txtDesde.current.value = '';
        txtHasta.current.value = '';
        setActivo(false);
        setValtipo(0);
    };


    const handleCloseSi = () => {
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
    };

    const cerrarModal = () => {
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
        blanquear();
    }

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                txtDesde.current.value = moment.utc(fechaSistema).format('YYYY-MM-DD');
                txtHasta.current.value = moment.utc(fechaSistema).format('YYYY-MM-DD');
                let fech = moment.utc(fechaSistema).format('YYYY-MM-DD');
                setHasta(fech);
                setDesde(fech);

                if (props.condicion === 'Listado por Tipo de Compromiso') {
                    setValtipo(2);
                }

            }}

        >
            <Modal.Header className='azulGradiant header-modal'>
                <div className='fw-bold text-light'><h3>{'Imprimir ' + props.condicion}</h3></div>
                <button className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>

            </Modal.Header>
            <Modal.Body>
                <Dimmer active={activate} inverted>

                </Dimmer>
                <div className='container-fluid rounded'>

                    <div className="tab-content" id="ex-with-icons-content">
                        <div className="tab-pane fade show active" id="tab-1" role="tabpanel" aria-labelledby="ex-with-icons-tab-1">

                            <fieldset className="row border-azul rounded mx-auto">
                                <legend className="float-none m-0 w-auto" >Datos</legend>

                                <div className='row m-0 px-0 mb-2'>

                                    <div className='col-sm-4 mb-1 px-1 mx-auto'>
                                        <div className="input-group input-group-sm m-0 w-100">
                                            <label className="input-group-text" id="inputGroup-sizing-sm">Desde Fecha:</label>
                                            <input type="date" className="form-control text-uppercase" onChange={onChange} ref={txtDesde} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="desde" />
                                        </div>
                                    </div>

                                    <div className='col-sm-4 mb-1 px-1 mx-auto'>
                                        <div className="input-group input-group-sm m-0 w-100">
                                            <label className="input-group-text" id="inputGroup-sizing-sm">Hasta Fecha:</label>
                                            <input type="date" className="form-control text-uppercase" onChange={onChange} ref={txtHasta} max={moment.utc(fechaSistema).format('YYYY-MM-DD')} aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="hasta" />
                                        </div>
                                    </div>

                                </div>

                                {props.condicion === 'Listado por Tipo de Compromiso' ? <div className='mb-1 col-sm-11 mx-auto'>
                                    <div className="input-group input-group-sm m-0 w-100">
                                        <label className="input-group-text" id="inputGroup-sizing-sm">Tipo de Compromiso:</label>
                                        <select className="form-select text-center" onChange={onChange} ref={txtTipo} aria-label="Default select example " id="tipo" >
                                            <option value="">--Seleccione--</option>
                                            <option value="1">TODOS</option>
                                            <option value="2">ORDEN DE COMPRA</option>
                                            <option value="3">PAGO DE OBRAS/SERVICIOS</option>
                                            <option value="4">ORDEN DE SERVICIO</option>
                                            <option value="5">PAGO DIRECTO</option>
                                            <option value="6">PAGO DE NOMINA</option>
                                        </select>
                                    </div>
                                </div> : ''}


                            </fieldset>

                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" ref={btnAcepta} disabled={activo} onClick={onChangeValidar} style={{ margin: '1px' }} className="btn btn-success btn-sm rounded-pill"><i className="far fa-check-circle"></i> Imprimir</button>
                <button type="button" ref={btnCancela} onClick={cancelar} style={{ margin: '1px' }} className="btn btn-sm btn-danger rounded-pill"><i className="fas fa-window-close"></i> Cancelar</button>
            </Modal.Footer>
            <Mensaje mensaje={mensaje}
                onHide={() => {
                    mensaje.titulo === 'Exito.' ?
                        cerrarModal() :
                        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                }
                } />
            <MensajeSiNo mensaje={mensajesino}
                onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
        </Modal>

    );
}